<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="住宿安排"
    >
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <div class="overflow-x-auto flex flex-col">
        <table
          cellpadding="15"
          style="
            min-width: 100%;
            width: fit-content;
            table-layout: fixed;
            border-collapse: collapse;
            text-align: center;
            font-size: 90%;
          "
        >
          <colgroup>
            <col width="120" />
            <col width="120" />
            <col width="120" />
            <col width="120" />
            <col />
            <col width="100" />
          </colgroup>
          <thead>
            <tr class="bg-gray-100" style="background-color: #f7f7f7">
              <th class="whitespace-nowrap">日期</th>
              <th class="whitespace-nowrap">房型</th>
              <th class="whitespace-nowrap">需求数量</th>
              <th class="whitespace-nowrap">已备</th>
              <th class="whitespace-nowrap text-left">已指派</th>
              <th class="whitespace-nowrap pr-2">操作</th>
            </tr>
          </thead>
        </table>
        <div
          style="overflow-y: auto; overflow-x: hidden; flex: 1"
          v-if="state.list_data?.length > 0"
        >
          <table
            cellpadding="15"
            style="
              min-width: 100%;
              width: fit-content;
              table-layout: fixed;
              border-collapse: collapse;
              text-align: center;
              font-size: 90%;
            "
          >
            <colgroup>
              <col width="120" />
              <col width="120" />
              <col width="120" />
              <col width="120" />
              <col />
              <col width="100" />
            </colgroup>
            <tbody>
              <template v-for="item in state.list_data">
                <tr class="bg-gray-50">
                  <td colspan="6">
                    <div class="flex gap-x-5 items-center text-sm">
                      <div
                        class="rounded-full bg-gray-300 flex items-center justify-center text-white text-lg w-10 h-10"
                      >
                        {{ item.hotel?.name?.substring(0, 1) }}
                      </div>
                      <strong>{{ item.hotel?.name }}</strong>
                      <el-icon class="ml-5"><phone /></el-icon>
                      <text class="ml-[-15px]">{{
                        item.hotel?.contact_phone
                      }}</text>
                      <el-icon class="ml-5"><Location /></el-icon>
                      <text class="ml-[-15px]">{{ item.hotel?.address }}</text>
                      <li class="flex-1"></li>
                      <el-button
                        type="primary"
                        icon="Edit"
                        size="small"
                        @click="
                          state.selectId = item.id;
                          state.showInfo = true;
                        "
                      >
                        编辑
                      </el-button>
                      <el-button
                        type="danger"
                        icon="Delete"
                        size="small"
                        class="!ml-[-10px]"
                        @click="onDelete(item)"
                      >
                        删除
                      </el-button>
                    </div>
                  </td>
                </tr>
                <template v-for="date in item.dateList">
                  <template
                    v-if="date.meetingHotelArrangeRoomTypeList?.length > 0"
                  >
                    <tr
                      v-for="(
                        room, roomIndex
                      ) in date.meetingHotelArrangeRoomTypeList"
                    >
                      <td
                        class="border-r border-b py-2 text-center"
                        :rowspan="date.meetingHotelArrangeRoomTypeList?.length"
                        v-if="roomIndex == 0"
                      >
                        {{ date.date }}
                      </td>
                      <td class="border-b">
                        <el-tag type="primary" effect="dark">{{
                          room.hotelRoomType?.name
                        }}</el-tag>
                      </td>
                      <td class="border-b">{{ room.need_count }}</td>
                      <td class="border-b">{{ room.ready_count }}</td>
                      <td class="border-b text-left">{{ room.guest_num }}</td>
                      <td class="border-b">
                        <el-button
                          type="success"
                          icon="Share"
                          link
                          size="small"
                          @click="
                            state.setting_title =
                              item.hotel?.name +
                              ' - ' +
                              room.hotelRoomType?.name +
                              ' - ' +
                              date.date;
                            state.selectChildId = room.id;
                            state.showSetting = true;
                          "
                        >
                          配置房间
                        </el-button>
                      </td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td class="border-r border-b py-2 text-center">
                      {{ date.date }}
                    </td>
                    <td
                      class="border-b text-left pl-5 text-xs text-gray-400"
                      colspan="10"
                    >
                      暂无排班~
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
        <div v-else class="text-center text-gray-400 text-sm mt-2">暂无住宿安排~</div>
      </div>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑住宿安排' : '新建住宿安排'"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :meeting_id="props.meeting_id"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showSetting"
    title="房间配置"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showSetting = false;
      }
    "
    style="width: 70%"
  >
    <text style="margin-top: -38px; margin-left: 70px; position: absolute">{{
      state.setting_title
    }}</text>
    <c_setting :id="state.selectChildId" @close="state.showSetting = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_hotelArrange_page,
  meeting_hotelArrange_delete,
} from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";
import c_detail from "./Detail.vue";
import c_setting from "./Setting/Index.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
    c_detail,
    c_setting,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      meeting_hotelArrange_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    // 存储合并信息
    let spanArr = [];
    let pos = 0;
    const calculateSpan = (data, prop) => {
      spanArr = [];
      pos = 0;

      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else {
          // 和上一行内容相同
          if (data[i][prop] === data[i - 1][prop]) {
            spanArr[pos] += 1;
            spanArr.push(0);
          } else {
            spanArr.push(1);
            pos = i;
          }
        }
      }
    };

    //列合并函数
    const arraySpanMethod = ({ row, column, rowIndex, columnIndex }) => {
      if (columnIndex == 0) {
        calculateSpan(state.table_list, "id");
        const _row = spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return { rowspan: _row, colspan: _col };
      }

      if (column.property === "name") {
        calculateSpan(state.table_list, "id");
        const _row = spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return { rowspan: _row, colspan: _col };
      }

      if (column.property === "handle") {
        calculateSpan(state.table_list, "id");
        const _row = spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return { rowspan: _row, colspan: _col };
      }
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_hotelArrange_delete, row.id, onLoad, {
        filed: "酒店住宿安排",
        name: row.hotel?.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
